<template>
  <div>
    <div class="flex w-full  pt-2 grid grid-cols-7  sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4 xs:grid-cols-4  ">
      <Lynx-Button
      class="mt-1"
        text="Editar empresa"
        icon="Edit"
        size="x-small"
        icon-size="4"
        @click.native="editingModalOpened = true"
        :disabled="getEmpresa.status === 'desativada'"
      />
      <Lynx-Button
      class="mt-1"
        text="Documentos"
        icon="Document"
        size="x-small"
        icon-size="4"
        @click.native="arquivosModalOpened = true"
      />
      <!-- <Lynx-Button
        text="O.S."
        icon="Support"
        size="x-small"
        icon-size="4"
        @click.native="ordemServicoModalOpened = true"
        :disabled="true"
      /> -->
      <Lynx-Button
      class="mt-1"
        text="Financeiro"
        icon="Money"
        size="x-small"
        icon-size="4"
        @click.native="financeiroModalOpened = true"
      />
      <Lynx-Button
      class="mt-1"
        text="Guias"
        icon="Document"
        size="x-small"
        icon-size="4"
        @click.native="guiasModalOpened = true"
      />
       <Lynx-Button v-if="getEmpresa.plans[0]"
       :disabled="true"
       class="mt-1"
        style="background-color: red;"
        :text="getEmpresa.plans[0].name"
        icon="Money"
        size="x-small"
        icon-size="4"
    
      />
      <Lynx-Button v-else
      class="mt-1"
       :disabled="true"
        text="Sem Plano"
        icon="Money"
        size="x-small"
        icon-size="4"
    
      />
      <!-- <Lynx-Button
      class="mt-1"
        text="Observação"
        icon="Eye"
        size="x-small"
        icon-size="4"
        @click.native="observacaoModalOpened = true"
      /> -->
      <Lynx-Button
      class="mt-1"
        text="Nota Fiscal"
        icon="Eye"
        size="x-small"
        icon-size="4"
        @click.native="notaFiscalModalOpened = true"
      />
    </div>

    <b-modal :active.sync="arquivosModalOpened">
      <Arquivos model-type="empresa" :model-id="getEmpresa.id"/>
    </b-modal>

    <b-modal :active.sync="ordemServicoModalOpened">
      <div class="bg-neutral-300 p-8">
        <ServiceOrderFormCreate/>
      </div>
    </b-modal>

    <b-modal :active.sync="editingModalOpened">
      <EditEmpresa :empresa="getEmpresa" @updated="$emit('updated')"/>
    </b-modal>

    <b-modal :active.sync="financeiroModalOpened">
      <HistoricoFinanceiro model-type="empresa" :model-id="getEmpresa.id"/>
    </b-modal>

    <b-modal :active.sync="guiasModalOpened">
      <Guias/>
    </b-modal>
       <b-modal :active.sync="linkerModalOpened" width="600px" id="modal-tall">
      <Linker/>
    </b-modal>
    <b-modal :active.sync="notaFiscalModalOpened" width="1400px"   >
      <NotaFiscalGerais @updated="$emit('updated')"/>
    </b-modal>
    <!-- <b-modal :active.sync="observacaoModalOpened"  >


  

      </b-modal> -->
  </div>
</template>

<script>
import EditEmpresa from "@/views/empresas/show/EditEmpresa";
import ServiceOrderFormCreate from "@/views/service-order/request/create/ServiceOrderFormCreate";
import Arquivos from "@/views/empresas/show/Arquivos";
import {mapGetters} from "vuex";
import Guias from "@/views/empresas/show/Guias";
import Linker from "@/views/empresas/show/casLinker"
import HistoricoFinanceiro from "@/views/empresas/show/HistoricoFinanceiro";
import EmpresaLabel from "./Label";
import NotaFiscalGerais  from "@/views/gerais/NotaFiscalGerais";
export default {
  name: "ButtonsBar",
  components: {HistoricoFinanceiro, Guias, Arquivos, ServiceOrderFormCreate, EditEmpresa,Linker,EmpresaLabel,NotaFiscalGerais},
  data() {
    return {
      arquivosModalOpened: false,
      ordemServicoModalOpened: false,
      editingModalOpened: false,
      financeiroModalOpened: false,
      guiasModalOpened: false,
      linkerModalOpened:false,
      notaFiscalModalOpened:false,
      observacaoModalOpened:false
      
    }
  },
  computed: {
    ...mapGetters(['getEmpresa']),
  },
}
</script>

<style scoped>

</style>
